export const otherActionType = {
    setotherinf: 'setotherinf',
};

export const setotherinf = (value) => ({ type: otherActionType.setotherinf, value });